import { render, staticRenderFns } from "./PagePreviewModal.vue?vue&type=template&id=6454ac3d&scoped=true"
import script from "./PagePreviewModal.vue?vue&type=script&lang=js"
export * from "./PagePreviewModal.vue?vue&type=script&lang=js"
import style0 from "./PagePreviewModal.vue?vue&type=style&index=0&id=6454ac3d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6454ac3d",
  null
  
)

export default component.exports